<template>
  <div
    style="border-color: white;"
    :class="`card px-${space} py-${space} mt-${space} wrapper-likedislike`"
    v-if="items.length > 0 && items[0].total > 0"
  >
    <div style="max-height: 45px;">
      <button class="btn" :class="isPanel ? 'font-size-title': ''" style="box-shadow: none;" @click="visible = !visible">
        <i class="fas fa-thumbs-up"></i>
        {{ this.$t('reports.likeDislike.likeDislikeLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <b-table :id="isPanel ? 'size-panels' : ''" :items="items" :fields="fields" caption-bottom sort-icon-left>
          <template v-slot:cell(progress)="row">
            <div v-if="row.item.type !== 'total'" class="form">
              <div class="progress-info">
                <div class="f-left">
                  {{ row.item.likes }}
                  <i class="far fa-thumbs-up likeColor"> </i>
                </div>
                <div class="f-right">
                  <i class="far fa-thumbs-down dislikeColor"> </i>
                  {{ row.item.dislikes }}
                </div>
              </div>
              <div>
                <b-progress
                  :value="row.item.progress"
                  :precision="1"
                  :max="100"
                ></b-progress>
              </div>
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div v-if="row.item.type !== 'total'" class="text-left" :style="`font-size: ${fontSize}px;`">
              {{ row.item.score }}%
            </div>
          </template>
          <template v-slot:cell(total)="row">
            <div class="text-left" :style="`font-size: ${fontSize}px;`">
              {{ row.item.total }}
            </div>
          </template>
          <!-- <template v-slot:table-caption>
            <div class="text-right px-3">
              Total de respostas válidas: {{ total }}
            </div>
          </template> -->
        </b-table>
        <div v-if="!isPanel" class="row">
          <div class="col-12 mt-2 text-right">
            <a
              @click="exportToXLS"
              :title="`${this.$t('reports.exportXlsLabel')}`"
            >
              <span class="xls">
                <i class="fas fa-file-download"></i>
              </span>
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import api from '@/services/api';
import EventBus from '../../../../../../eventBus';

export default {
  name: 'ScoreCsat',
  props: ['showCollapsed', 'dataGraph'],
  data: () => ({
    isBusy: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    items: [],
    loader: false,
    likeDislikeData: [],
    fields: [],
    totalAnswers: 0,
    lang: 'br',
    isPanel: false,
    space: 2,
    fontSize: 16,
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountLikeDislike();
    },
    myActionId: function watchMyActionId() {
      this.mountLikeDislike();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountLikeDislike();
    },
    myIh1: function watchMyIh1() {
      this.mountLikeDislike();
    },
    myHierarchies1: function watchMyHierarchies1(){
      this.mountLikeDislike();
    },
    myIh2: function watchMyIh2() {
      this.mountLikeDislike();
    },
    myHierarchies2: function watchMyHierarchies2(){
      this.mountLikeDislike();
    },
    calendarDates: function watchDates() {
      this.mountLikeDislike();
    },
    myMetric: function watchMyMetric() {
      this.mountLikeDislike();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountLikeDislike();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountLikeDislike();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountLikeDislike();
    },
  },
  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    async mountLikeDislike() {
      this.loader = true;
      const response = await api.get(`reports/get-like-dislike`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
          reportType: 'LIKE/DISLIKE'
        },
      });
      this.likeDislikeData = response.data;
      this.items = [];
      this.likeDislikeData.map((obj) => {
        if (obj.question.toLowerCase() === 'total') {
          this.items.push({
            question: this.$t('reports.likeDislike.totalAnswersLabel'),
            type: 'total',
            total: obj.total,
          });
          this.totalAnswers = obj.total;
          this.total = obj.total;
        } else {
          // eslint-disable-next-line
          if (obj.total > 0) {
            this.items.push({
              question: obj.question,
              progress: obj.percentil,
              score: obj.percentil.toFixed(2),
              likes: obj.percentil.toFixed(2),
              dislikes: (100 - obj.percentil).toFixed(2),
              total: obj.total,
            });
          }
        }
      });
      this.loader = false;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = [
        this.$t('reports.likeDislike.addQuestionLabel'),
        this.$t('reports.likeDislike.scoreLabel'),
        this.$t('reports.likeDislike.totalLabel'),
      ];
      const arr = [];
      this.items.forEach((el) => {
        arr.push({
          [this.$t('reports.likeDislike.addQuestionLabel')]: el.question,
          [this.$t('reports.likeDislike.scoreLabel')]: el.score,
          [this.$t('reports.likeDislike.totalLabel')]: el.total,
        });
      });
      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-like-dislike');
      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-like-dislike'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );
      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-like-dislike.xlsx');
      document.body.appendChild(link);
      link.click();
    },
    async mountCardPanel(data) {
      this.loader = true;
      const response = await api.get(`reports/get-like-dislike`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: null,
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          // startDate: '2022-01-01',
          // endDate: '2022-07-08',
          ih1: data.ih1 ? data.ih1._id : null,
          metric: data.metric ? data.metric : null,
          period: data.period ? data.period : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          // indicatorRange: this.indicatorData.range,
          lang: this.lang,
          reportType: 'LIKE/DISLIKE',
        },
      });
      this.likeDislikeData = response.data;
      this.items = [];
      this.likeDislikeData.map((obj) => {
        this.items.push({
          question: obj.question,
          progress: obj.percentil,
          score: obj.percentil,
          likes: obj.percentil,
          dislikes: 100 - obj.percentil,
          total: obj.total,
        });
      });
      this.totalAnswers = 0;
      for (let i = 0; i < this.items.length; i += 1) {
        this.totalAnswers += this.items[i].total;
      }
      this.items.push({
        question: this.$t('reports.likeDislike.totalAnswersLabel'),
        type: 'total',
        total: this.totalAnswers,
      });
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.likeDislike.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      { key: 'progress', class: 'progressTh' },
      {
        key: 'score',
        label: this.$t('reports.likeDislike.scoreLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: this.$t('reports.likeDislike.totalLabel'),
        sortable: true,
        class: 'totalTh',
      },
    ];
  },
  mounted() {
    this.visible = !this.showCollapsed;
    this.lang = this.$i18n.locale;
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.mountCardPanel(this.dataGraph);
      EventBus.$on('update-like-dislike', (items) => {
        this.mountCardPanel(items);
      });
      this.fontSize = 12;
      this.space = 0;
    } else {
      this.mountLikeDislike();
      EventBus.$on('filter-rankings', () => {
        this.mountLikeDislike();
      });
      this.space = 2;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-likedislike .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-likedislike .btn .btn-light .collapsed {
  background-color: transparent;
}
.progress-info {
  font-size: 12px;
  display: ruby-text;
}
.f-left {
  float: left;
}
.f-right {
  float: right;
}
.likesTh {
  padding-right: 0px !important;
  padding-top: 5px !important;
  font-size: 12px;
}
.dislikesTh {
  padding-left: 0px !important;
  padding-top: 5px !important;
  font-size: 12px;
}
.progress {
  background-color: #d62027;
}
.likeColor {
  color: #4ce595;
}
.dislikeColor {
  color: #d62027;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid #fff;
}
.form {
  display: grid;
  // position: absolute;
  width: 150px;
  right: 155px;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #1dc86e;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/like-dislike.vue